/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2017 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/

import { Injectable } from "@angular/core";
import { ApiGatewayService } from "src/app/shared/services/api-gateway/api-gateway.service";
@Injectable({
  providedIn: "root",
})
export class LandingPageService {
  constructor(public _apiGatewayService: ApiGatewayService) {}

  getLandingPageAppName() {
    return this._apiGatewayService.get("/commonlookup/menus");
  }
}
